module.exports = __webpack_public_path__ + "static/media/bluetooth-b.0f2a457a.svg";